export default __webpack_public_path__ + "static/media/clapping.973be054.gif";